import {
  Component,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  TemplateRef,
} from "@angular/core";

import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs/Subscription";
import { ModaleErroreStore } from "@store/modale-errore.store";
import { ErrorVO } from "@vo/errorVO";
import { DettaglioErroreVO } from "@app/shared/vo/dettaglio-erroreVO";

@Component({
  selector: "app-modale-errore",
  templateUrl: "./modale-errore.component.html",
  providers: [],
})
export class ModaleErroreComponent implements AfterViewInit, OnDestroy {
  public errore: ErrorVO;
  public messaggioErrore: string;
  public listaErrori: DettaglioErroreVO[];
  private sub: Subscription;
  public descrizione: string;
  public titolo: string = "Errore";
  displayedColumns: string[] = ["messaggioErrore"];

  @ViewChild("modale", { static: false })
  public modale: TemplateRef<any>;

  public modalRef: BsModalRef;

  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };

  //@ViewChild("modale", { static: false }) public modale: ModalDirective;

  constructor(
    private modaleErrore: ModaleErroreStore,
    private modalService: BsModalService
  ) {
    this.listaErrori = [];
  }

  ngAfterViewInit() {
    this.modalService.onHide.subscribe((_) => {
      console.log("onHide modale errore");
      this.modaleErrore.resetErrori();
    });
    this.sub = this.modaleErrore
      .getErrori()
      .filter((errore) => errore !== null)
      .subscribe((errore) => {
        console.log("errore in subscription", errore);
        this.gestisciErrore(errore);
      });
  }

  chiudiModale() {
    this.listaErrori = [];
    console.log(
      "[ModaleErroreComponent][gestisciErrore] listaErrori: ",
      this.listaErrori
    );
    this.modalRef.hide();
    this.modaleErrore.resetErrori();
  }

  private gestisciErrore(errore: ErrorVO) {
    if (errore) {
      this.modalRef = this.modalService.show(this.modale, this.config);

      console.log(
        "[ModaleErroreComponent][gestisciErrore] ricevo un errore: ",
        errore
      );
      this.errore = errore;
      this.messaggioErrore = this.errore.message
        ? this.errore.message.replace(/\n/g, "<br/><br/>")
        : this.errore.message;
      this.titolo = this.messaggioErrore && this.messaggioErrore.indexOf("Operazione eseguita parzialmente") !== -1
        ? "Avviso"
        : "Errore";
      if (
        this.errore &&
        this.errore.listaErrori &&
        this.errore.listaErrori.length > 0
      ) {
        this.listaErrori = this.errore.listaErrori;
      }
      if (errore.status === 412 && this.listaErrori.length > 0) {
        this.descrizione =
          "Non è stato possibile eseguire l'operazione per i seguenti motivi:";
        this.messaggioErrore = undefined;
      } else if (errore.status === 500 && this.listaErrori.length > 0) {
        this.descrizione = "Errore 500: ";
      }
      console.log(
        "[ModaleErroreComponent][gestisciErrore] listaErrori: ",
        this.listaErrori
      );
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      console.log("[ModaleErroreComponent][ngOnDestroy] unsubscribe: ");
      this.sub.unsubscribe();
    }
  }

  public inviaSegnalazione() {}
}
